// TODO: Add a cart loading state
// TODO: Put this logic in the mini cart component?

import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { isDate } from '@aspenware-library/helper-fns'

export const CartUtils = {
  data() {
    return {
      hasData: false,
    }
  },
  methods: {
    toggleShowCart() {
      var scrollToElement = $('#commerce-store')
      var container = $('body, html')
      this.toggleCart()
      if (this.showCart) {
        this.$store.dispatch('cart/sendGA4ViewCartEvent', this.findCartItems)
      }
      container.animate({
        scrollTop: scrollToElement.offset().top,
      })
    },
    setEditCart(val) {
      this.setEditCart(val)
    },
    getCartData(attributeName, keepCartOpen, onCartDataLoaded) {
      var self = this
      var keepOpen = false
      var forceOpen = false
      if (keepCartOpen) {
        keepOpen = keepCartOpen
      }
      if (self.$route.query.cart) {
        forceOpen = self.$route.query.cart
      }

      // Calling generic get assignable members using no product or attributes
      var attributes = []
      var postData = {
        ProductId: null,
        Filters: attributes,
      }
      self.$store.commit('global/setLoadingGroupMembers', true)
      self.getCartItems(keepOpen, forceOpen, onCartDataLoaded)
    },
    async getCartItems(keepOpen, forceOpen, onCartDataLoaded) {
      var self = this

      const cartUrl = '/api/minicart'

      const cartData = await this.fetch({
        url: cartUrl,
      })

      if (cartData) {
        this.hasData = true
        let assignedMembers = []
        let hasUnassigned = false

        cartData.Items.forEach((cartItem) => {
          cartItem.AssignedTo = this.parseAttributes(cartItem)

          if (!_.isEmpty(cartItem.AssignedToContactInfo)) {
            assignedMembers.push(cartItem.AssignedToContactInfo)
          } else if (!hasUnassigned) {
            hasUnassigned = true
          }
        })

        assignedMembers = _.uniqBy(assignedMembers, (member) => {
          return member.Id
        })

        if (!forceOpen && (cartData.TotalProducts < 1 || !keepOpen)) {
          cartData.showCart = false
        } else {
          cartData.showCart = true
        }

        const sortedCartByAssignment = _.sortBy(cartData.Items, (item) => {
          return item.AssignedTo
        })
        const sortedMembers = _.sortBy(assignedMembers, (member) => {
          return member.Id
        })

        cartData.Items = sortedCartByAssignment
        cartData.AssignedMembers = sortedMembers
        cartData.HasUnassigned = hasUnassigned

        // Update the brand header cart count until the page gets refreshed with the proper value
        let cartCountElement = document.querySelector('#header-cart-count')
        if (cartCountElement) {
          cartCountElement.textContent = cartData.TotalProducts
        }

        // Used for thredbo. TODO: Make this based on a NOP setting
        let thredboCartCountElement = document.querySelector('.cart-items-count')
        if (thredboCartCountElement) {
          thredboCartCountElement.textContent = cartData.TotalProducts
        }

        this.updateCookie({
          pageName: this.$route.params.subcategory || this.$route.params.category,
          pageUrl: this.$route.path,
        })
        this.updateCart(cartData)

        if (onCartDataLoaded) {
          self.setEditCart(false)
          onCartDataLoaded()
        }
      }
    },
    parseAttributes(cartItem) {
      var attrs = cartItem.AttributeInfo.split('<br />') || []
      var subAttrs = attrs.filter((attr) => attr.includes(`${this.subAttributeKeyword}:`))

      if (subAttrs.length > 0) {
        attrs = attrs.filter((attr) => !attr.includes(`${this.subAttributeKeyword}:`))
        subAttrs.forEach((attr) => {
          if (attr.includes(this.subAttributeDelimiter)) {
            let multi = attr.split(this.subAttributeDelimiter)
            multi.forEach((val) => {
              if (!val.includes(`${this.subAttributeKeyword}:`)) {
                val = `${this.subAttributeKeyword}: ${val}`
              }
              attrs.push(val)
            })
          } else {
            attrs.push(subAttrs[0])
          }
        })
      }

      var newAttributes = []
      var assignedTo = null
      let isGolfProduct = false

      if (
        cartItem.AttributeInfo.toUpperCase().includes('DATE:') &&
        cartItem.AttributeInfo.toUpperCase().includes('TIME:') &&
        cartItem.AttributeInfo.toUpperCase().includes('HOLES:')
      ) {
        isGolfProduct = true
      }

      this.$set(cartItem, 'IsGolfProduct', isGolfProduct)

      if (cartItem.AttributeInfo === '' || !cartItem.AttributeInfo) {
        return newAttributes
      }

      for (let attribute of attrs) {
        let attrObject = {}
        let attrValue = null

        if (attribute.includes(':')) {
          const attrElements = attribute.split(': ')
          attrObject.name = attrElements[0]
          attrValue = attrElements[1]
        } else {
          attrObject.name = 'unknown_name'
          attrValue = attribute.trim()
        }

        var isMultiDate = false
        var allDates = attrValue.split(/\|/g)
        if (allDates && allDates.length > 1) {
          isMultiDate = true
          for (let singleDate of allDates) {
            isMultiDate = isDate(singleDate)
          }
        }
        if (isMultiDate) {
          for (let singleDate of allDates) {
            let attrDateObject = {}
            attrDateObject.name = 'Start Date'
            attrDateObject.value = singleDate
            newAttributes.push(attrDateObject)
          }
          continue
        }

        if (attrValue.includes('|')) {
          attrValue = attrValue.split(/\|(.+)/)[0].trim()
        }

        attrObject.value = attrValue

        // Check if the attribute is the assigned to field
        attrObject.IsAssignedTo = attrObject.name == 'AssignedTo'
        if (attrObject.IsAssignedTo) {
          assignedTo = {}
          assignedTo.Id = attrObject.value

          var member = _.find(this.$store.getters['global/groupMembers'], function (member) {
            return member.ContactInfoId == assignedTo.Id
          })
          if (member) {
            assignedTo.Name = member.FirstName + ' ' + member.LastName
          }
        }

        // Check if the attribute is the lock ID field
        attrObject.IsLockId = attrObject.name == 'Lock Id'

        attrObject.IsActivityTime = attrObject.name.toUpperCase().includes('TIME') && attrObject.value.includes(':')

        if (!attrObject.IsAssignedTo && !attrObject.IsActivityTime) {
          // Check if the attribute is a date
          // @NOTE validation streamlined as part of TCW-1398
          let value = attrObject.value
          if (value) {
            const alphabetRegex = /[a-zA-Z]/g
            if (alphabetRegex.test(value)) {
              const valid = [
                moment.months(),
                moment.monthsShort(),
                moment.weekdays(),
                moment.weekdaysMin(),
                moment.weekdaysShort(),
              ]

              attrObject.IsDate = !valid.some((v) => value.includes(v)) || !isDate(value) ? false : true
            } else {
              attrObject.IsDate = isDate(value)
            }
          }
        }

        if (isGolfProduct) {
          attrObject.IsReservationTime = attrObject.name.toUpperCase().includes('TIME')
          attrObject.IsReservationHoles = attrObject.name.toUpperCase().includes('HOLES')
          attrObject.IsPrice = attrObject.name.toUpperCase().includes('RESERVATION PRICE')
          if (attrObject.IsPrice) {
            const resPrice = cartItem.Quantity * attrValue
            this.$set(cartItem, 'ReservationPrice', resPrice)
          }
          if (attrObject.IsNewPrice) {
            this.$set(cartItem, 'ReservationNewPrice', attrValue)
          }
        }
        newAttributes.push(attrObject)
      }

      cartItem.Attributes = newAttributes

      return assignedTo
    },
    ...mapActions({
      toggleCart: 'cart/toggleCart',
      updateCart: 'cart/updateCart',
      setEditCart: 'cart/setEditCart',
      updateCookie: 'global/updateCookie',
      fetch: 'api/get',
    }),
  },
  computed: {
    ...mapGetters({
      selectedCategoryId: 'products/selectedCategoryId',
      products: 'products/selectedProduct',
      showCart: 'cart/showCart',
      category: 'products/category',
      categories: 'products/categories',
      cart: 'cart/cart',
      cartItemCount: 'cart/cartItemCount',
      cartHash: 'cart/cartHash',
      subAttributeDelimiter: 'cart/getOrderSubAttributeDelimiter',
      subAttributeKeyword: 'cart/getOrderSubAttributeKeyword',
    }),
    findCartItems() {
      return this.cart.Items
    },
    categoryName() {
      return this.category.Name
    },
  },
}
